import { createElement, useState } from "react";
import { Trans } from "react-i18next";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { deleteHttp } from "@common/api/apiShared";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";
import { IDeleteInternalAssessmentGroupDialogProps } from "./DeleteInternalAssessmentGroupDialog";

export default function useDeleteInternalAssessmentGroup(props: IDeleteInternalAssessmentGroupDialogProps) {
    const snackbar = useDotLegalSnackbar();

    const [confirmDelete, setConfirmDelete] = useState(false);

    const removeMutation = useDotLegalMutation(remove);

    const deleteClick = () => {
        removeMutation.mutateAsync(undefined, {
            onSuccess: () => {
                props.onDeleted();
                snackbar.show(createElement(Trans, { i18nKey: "itemDeleted", values: { name: props.internalAssessmentGroupName } }));
            },
        });
    };

    return {
        deleteClick,
        confirmDelete,
        setConfirmDelete,
        inProgress: removeMutation.isLoading,
    };

    async function remove() {
        return await deleteHttp<string>(`/internalAssessmentGroups/${props.internalAssessmentGroupId}`);
    }
}
